import { Link } from "react-router-dom";

export default function EmptyState({ icon: Icon, title, description, actionLabel, actionTo, onAction, testId = "empty-state" }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center text-center py-20 px-6">
      {Icon && (
        <div className="w-16 h-16 rounded-full bg-aqua/10 flex items-center justify-center mb-6">
          <Icon className="w-7 h-7 text-aqua" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-xl font-bold text-ink">{title}</h3>
      {description && <p className="mt-2 text-greyish max-w-md">{description}</p>}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          data-testid="empty-state-action"
          className="mt-6 inline-flex items-center gap-2 bg-aqua text-white px-6 py-3 rounded-md font-semibold hover:bg-aqua-dark transition-colors"
        >
          {actionLabel}
        </Link>
      )}
      {actionLabel && onAction && !actionTo && (
        <button
          onClick={onAction}
          data-testid="empty-state-action"
          className="mt-6 inline-flex items-center gap-2 bg-aqua text-white px-6 py-3 rounded-md font-semibold hover:bg-aqua-dark transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
